import { Component, Input } from '@angular/core';
import Swal from 'sweetalert2';

import { AvaliationItemComponent } from 'src/app/@core/models/item-component';
import { TranslateSharedModule } from 'src/app/translate/translate.module';

@Component({
  selector: 'app-editor-component-avaliation',
  templateUrl: 'avaliation.component.html'
})
export class EditorAvaliationComponent {
  @Input() item: AvaliationItemComponent;

  blocked = false;
  listMarkerLetter = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];

  constructor(private translateService: TranslateSharedModule) {
  }

  onSubmit() {
  }

  getArray(length: number): Array<any> {
    const arr = [];
    for (let i = 0; i < length; i++) {
      arr.push(i);
    }
    return arr;
  }
  async verify(question: {correct: string, feedback: string}) {
    if (question.correct) {
        Swal.fire(await this.translateService.showTranslator('YouGot'), question.feedback, 'success');
    } else {
        Swal.fire('Ops...', question.feedback, 'error');
    }
  }

}
